/**
 * User service — API calls for User_Record management.
 */

import { api } from './api';

export interface User {
  id: string;
  email: string;
  name: string;
  last_name: string;
  user_type: 'client' | 'consultant' | 'admin';
  cell_phone: string | null;
  position: string | null;
  company_id: string;
  company_name?: string;
  date_of_birth: string | null;
  status: 'active' | 'inactive';
  created_at: string;
  updated_at: string;
}

export interface UserCreatePayload {
  name: string;
  last_name: string;
  email: string;
  user_type: 'client' | 'consultant' | 'admin';
  cell_phone?: string | null;
  position?: string | null;
  company_id: string;
  date_of_birth?: string | null;
  status?: 'active' | 'inactive';
}

export interface UserUpdatePayload {
  name?: string;
  last_name?: string;
  user_type?: 'client' | 'consultant' | 'admin';
  cell_phone?: string | null;
  position?: string | null;
  company_id?: string;
  date_of_birth?: string | null;
  status?: 'active' | 'inactive';
}

export const userService = {
  async list(companyId?: string): Promise<User[]> {
    const query = companyId ? `?company_id=${companyId}` : '';
    const response = await api.get<{ data: User[] }>(`/admin/users${query}`);
    return response.data;
  },

  async get(id: string): Promise<User> {
    const response = await api.get<{ data: User }>(`/admin/users/${id}`);
    return response.data;
  },

  async create(payload: UserCreatePayload): Promise<User> {
    const response = await api.post<{ data: User }>('/admin/users', payload);
    return response.data;
  },

  async update(id: string, payload: UserUpdatePayload): Promise<User> {
    const response = await api.put<{ data: User }>(`/admin/users/${id}`, payload);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/admin/users/${id}`);
  },
};
